export enum StudyReportStateEnum {
  Pending = 1
}

export class StudyReportStateFilter {
  Id: number;
  Name: string;
}

